import { SET_LOADING } from './types';

export const mutations = {
  [SET_LOADING]: (state, payload) => {
    state.loading += payload;

    if (state.loading < 0) {
      state.loading = 0;
    }
  }
};
